export default __webpack_public_path__ + "static/nude2-c17792575883a9e04a44976bec247f36.jpg";